import React, { Children, FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import "../../../assets/css/table/Table.css";
import "../../../assets/css/CatalogTable.css";
import { useDispatch } from "react-redux";
import { IPracticeIndustry } from "../../../interfaces/models/IPracticeIndustry";
import useViewport from "../../../hooks/useViewPort";
import Axios from "../../../utils/axios";
import { hideLoader, showLoader } from "../../../redux/loaderActions";
import ExcelModal from "../../../components/Atomos/Modals/ExcelModal";
import CatalogTitle from "../../../components/Moleculas/Catalog Text/CatalogTitle";
import CounterTotalCatalog from "../../../components/Moleculas/Catalog Text/CounterTotalCatalog";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import Excel from "../../../components/Atomos/Icons/Excel";
import Plus2 from "../../../components/Atomos/Icons/Plus";
import VisibleColumns from "../../../components/Organismos/Table/VisibleColumns";
import { exportStyledExcel } from "../../../utils/excel/exportStyledExcel";

interface ICatalogTableProps {
  newItemAction?: () => void;
  title?: string;
  catalogName?: string;
  headers: string[];
  route: string;
  totalCount: number;
  isfiltered: boolean;
  data: any[];
  totalData?: any[];
  HandleFilter?: (field: string, value: string) => void;
  onsubmit?: (e: FormEvent<HTMLFormElement>) => void;
  clearSelections?: () => void;
  shouldFormat?: boolean;
  hasTotalData?: boolean;
  GetTotalData?: (all: boolean) => Promise<any[]>;
  linkToAdd?: string;
  noNewCatalog?: boolean;
  noExcelExport?: boolean;
  showAddButton?: boolean;
  selectedTab?: number;
  catalogShortName?: string;
  hideVisibleColumnsButton?: boolean;
  children?: React.ReactNode;
  practiceIndustries?: IPracticeIndustry[];
  resetSignal?: number;
  personFromDto?: boolean;
  exportData?: any;
  regions?: any[];
  firmData?: any;
  currentFirm?: any;
  currentPerson?: any;
}

const CatalogTableC: React.FC<ICatalogTableProps> = (
  props: ICatalogTableProps
) => {
  const { viewportWidth } = useViewport();
  const dispatch = useDispatch();

  function formatDate(value: string) {
    const formattedDate = new Date(Number(value) * 1000).toLocaleDateString(
      "en-US",
      {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      }
    );

    return formattedDate;
  }

  const formatDateValue = (value: string) => {
    return new Date(Number(value) * 1000).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const axios = new Axios();

  const [open, setOpen] = useState<boolean>(false);
  const [totalData, setTotalData] = useState<any[]>([]);
  console.log(props.currentFirm,"props.currentFirm")
  const GetTotalData = async () => {
    let datapassed: any[] = [];
    let queryString = `/${props.route}`;

    if (props.selectedTab === 0) {
      queryString += "?resourceId=mappingPage&countOnly=true";
    } else if (props.selectedTab === 1) {
      queryString += "?resourceId=mappingPage&isMapped=true&countOnly=true";
    }
    const fetchTotalCount = async () => {
      try {
        if (props.selectedTab && props.selectedTab === 0) {
          let newString = "&resourceId=mappingPage&countOnly=true";
          queryString += newString;
        }
        const response = await axios.Get(queryString);
        const data = response.data;
        if (data != null) {
          setTotalData(data);
          datapassed = data;
        }
      } catch (error) {
        console.error("Error al obtener la información de la columna:", error);
      }
    };
    await fetchTotalCount();
    return datapassed;
  };

  const excelExport = async (jsonData: any[]) => {
    try {
      setOpen(false);

      const resolvedData = jsonData.map((item) => {
        const rowData: { [key: string]: any } = {};
        for (const header of props.headers) {
          const key = header.replace(/ /g, "_");
          let value = item[key] !== undefined ? item[key] : "";

          if (key === "_ts") {
            value = formatDateValue(value);
          } else if (Array.isArray(value)) {
            value = value.join(", ");
          }

          const formattedHeader =
            header === "_ts" || header === "dateCreated"
              ? "Created Date"
              : header;
          rowData[formattedHeader] = value;
        }
        return rowData;
      });

      const currentDate = new Date();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const year = currentDate.getFullYear();

      const formattedDate = `${month}_${day}_${year}`;
      const outputFile = `${props.route}_${formattedDate}.xlsx`;

      await exportStyledExcel({
        filename: outputFile,
        title: props.title || props.catalogName || props.route,
        documentType: props.catalogName || props.route,
        rows: resolvedData,
      });

    } catch (e: any) {
      console.error(e.message);
    }
  };

  const dataExcelExport = async (current: boolean) => {
    if (!current) {
      let dataToExport: any[] = [];

      if (!props.hasTotalData) {
        dataToExport = await GetTotalData();
      }
      else {
        dataToExport = (await props.GetTotalData?.(true)) ?? [];
      }
      dataToExport.forEach((item: any) => {
        if (item._ts) {
          item["created_date"] = formatDate(item._ts);
        }
      });

      excelExport(dataToExport);
    } else {
      try {
        if (!props.hasTotalData) {
          excelExport(props.exportData ? props.exportData : props.data);
        }
        else {
          excelExport((await props.GetTotalData?.(false)) ?? []);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  return (
    <>
      <ExcelModal
        open={open}
        setOpen={setOpen}
        dataExcelExport={() => dataExcelExport(true)}
      />
      <section className=" CatalogTableMain relative">
        {props.title && (
          <CatalogTitle title={props.title} className="text-disclosure-primary-dark" />
        )}

        <div className="flex flex-col md:flex-row h-auto w-full">
          <CounterTotalCatalog
            title={`${props.catalogName} (${props.totalCount} Total)`}
            className=" bg-disclosure-primary-dark text-neutral first-letter:uppercase"
          ></CounterTotalCatalog>

          <div className="flex lg:flex-row-reverse">
            <div className="flex w-full">
              {!props.noExcelExport && (
                <div className="flex-1">
                  <NewButton
                    text={viewportWidth < 1024 ? `Export` : `Export to Excel`}
                    color="excel"
                    size="large"
                    content="textIcon"
                    onClick={() => setOpen(true)}
                    icon={<Excel />}
                  />
                </div>
              )}
              {!props.noNewCatalog && (
                <Link
                  className="flex-1"
                  to={
                    props.linkToAdd
                      ? (props.linkToAdd as string)
                      : `/Articles/Manage/Create`
                  }
                  state={{ newItem: true, currentFirm: props.currentFirm, currentPerson: props.currentPerson }}
                >
                  <NewButton
                    text={
                      viewportWidth < 1024
                        ? `New`
                        : `Submit Article`
                    }
                    color="primary"
                    size={"large"}
                    onClick={() => props.newItemAction && props.newItemAction()}
                    content="textIcon"
                    icon={<Plus2 />}
                  />
                </Link>
              )}
            </div>
            {!props.isfiltered &&
              !props.hideVisibleColumnsButton &&
              props.resetSignal && (
                <VisibleColumns
                  resetSignal={props.resetSignal}
                  className={"right-0"}
                  pageHeaders={props.headers}
                ></VisibleColumns>
              )}
          </div>
        </div>

        <div className="bg-white w-full flex flex-col mt-6 items-start self-stretchable">
          {Children.map(props.children, (child) => (
            <> {child} </>
          ))}
        </div>
      </section>
    </>
  );
};

export default CatalogTableC;
